import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Mail, MapPin, ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";
import Footer from "@/components/Footer";

export default function Contacto() {
  const navigate = useNavigate();
  return (
    <div style={{ background: "var(--af-black)", minHeight: "100vh" }}>
      <div className="af-container flex items-center gap-3" style={{ height: 68, borderBottom: "1px solid var(--af-border-dark)" }}>
        <button data-testid="contacto-back" onClick={() => navigate("/")} className="text-white/80 hover:text-af-orange-core"><ArrowLeft size={22} /></button>
        <Link to="/"><Logo height={40} /></Link>
      </div>
      <div className="af-container py-12 max-w-2xl" data-testid="contacto">
        <h1 className="h-impact text-white text-3xl md:text-4xl mb-8">Contacto</h1>
        <div className="space-y-4">
          <div className="af-card p-5 flex items-start gap-4">
            <Mail className="text-af-orange-core mt-1" size={22} />
            <div>
              <div className="text-white font-semibold">Atención a usuarios</div>
              <a href="mailto:atencion@autofinanza.com.mx" className="text-af-orange-core">atencion@autofinanza.com.mx</a>
            </div>
          </div>
          <div className="af-card p-5 flex items-start gap-4">
            <ShieldCheck className="text-af-orange-core mt-1" size={22} />
            <div>
              <div className="text-white font-semibold">Privacidad y derechos ARCO</div>
              <a href="mailto:privacidad@autofinanza.com.mx" className="text-af-orange-core">privacidad@autofinanza.com.mx</a>
            </div>
          </div>
          <div className="af-card p-5 flex items-start gap-4">
            <MapPin className="text-af-orange-core mt-1" size={22} />
            <div>
              <div className="text-white font-semibold">Domicilio</div>
              <div className="text-white/70 text-sm">Privada Valle Dorado No. 1, Col. Lomas de Urbiquinta, C.P. 52930, Atizapán de Zaragoza, Estado de México, México.</div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
